import styled from 'styled-components';

export const StyledCard = styled.div<{
  padding?: 'sm' | 'md' | 'lg';
  hover?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.cardBackground};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.colors.cardShadow};
  transition: ${({ theme }) => theme.transitions.default};

  ${({ padding = 'md', theme }) => {
    switch (padding) {
      case 'sm':
        return `padding: ${theme.spacing.md};`;
      case 'lg':
        return `padding: ${theme.spacing.xl};`;
      default:
        return `padding: ${theme.spacing.lg};`;
    }
  }}

  ${({ hover, theme }) =>
    hover &&
    `
    cursor: pointer;
    &:hover {
      box-shadow: ${theme.colors.cardShadowHover};
      transform: translateY(-2px);
    }
  `}

  /* Responsive padding adjustments */
  @media ${({ theme }) => theme.media.maxMd} {
    ${({ padding = 'md', theme }) => {
      switch (padding) {
        case 'sm':
          return `padding: ${theme.spacing.sm};`;
        case 'lg':
          return `padding: ${theme.spacing.lg};`;
        default:
          return `padding: ${theme.spacing.md};`;
      }
    }}
  }

  @media ${({ theme }) => theme.media.maxSm} {
    ${({ padding = 'md', theme }) => {
      switch (padding) {
        case 'sm':
          return `padding: ${theme.spacing.xs};`;
        case 'lg':
          return `padding: ${theme.spacing.md};`;
        default:
          return `padding: ${theme.spacing.sm};`;
      }
    }}
    
    border-radius: ${({ theme }) => theme.borderRadius.md};
  }

  /* Touch device optimizations */
  @media ${({ theme }) => theme.media.touch} {
    ${({ hover }) =>
      hover &&
      `
      &:hover {
        transform: none;
      }
      
      &:active {
        transform: scale(0.98);
      }
    `}
  }

  /* Reduced motion support */
  @media ${({ theme }) => theme.media.reducedMotion} {
    transition: none;
    
    &:hover, &:active {
      transform: none;
    }
  }
`;

export const StyledCardHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.lg};

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
`;

export const StyledCardContent = styled.div`
  /* Content styles can be added here */
`;

export const StyledCardFooter = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
  padding-top: ${({ theme }) => theme.spacing.lg};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
`;
